import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Smart money formatter: shows 3 decimals when the value has sub-cent precision
// (e.g. $0.075, $0.025, $0.050), otherwise the standard 2 decimals ($5.00).
// Use this for any amount that may come from level/team percentage payouts.
export function fmtMoney(amount) {
  const n = Number(amount || 0);
  const two = Math.round(n * 100) / 100;
  if (Math.abs(n - two) >= 0.0005) {
    return n.toFixed(3);
  }
  return n.toFixed(2);
}
